import React from 'react';
import { useTranslation } from 'react-i18next';

const Projects = ({ content }) => {
  const { t } = useTranslation();
  
  return (
    <section id="projects" className="py-20">
      <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-center mb-16">{t('projects.title')}</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {content.items.map((project, index) => (
            <div 
              key={index} 
              className="rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow"
            >
              {project.isVideo ? (
                <video 
                  src={project.image} 
                  alt={`Project ${index + 1}`} 
                  className="w-full h-48 object-cover"
                  autoPlay 
                  muted 
                  loop 
                  playsInline
                />
              ) : (
                <img 
                  src={project.image} 
                  alt={`Project ${index + 1}`} 
                  className="w-full h-48 object-cover" 
                />
              )}
              <div className="p-6">
                <h3 className="text-xl font-semibold mb-2">{t(`projects.items.${index}.title`)}</h3>
                <p className="text-gray-600 mb-4">{t(`projects.items.${index}.description`)}</p>
                <a 
                  href={project.link} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="inline-block px-4 py-2 bg-custom text-white rounded-button hover:bg-custom/90 transition-colors"
                >
                  {t('projects.viewProject')}
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
